import { FeedbackButton } from "@/components/canvas/feedback-button";

export function FeedbackPage() {
  return (
    <div className="relative h-[600px] w-full rounded-xl border border-white/[0.06] bg-[#0e0e10]">
      <div className="flex h-full items-center justify-center text-sm text-muted/40">
        Canvas area — the feedback button is in the bottom-right corner
      </div>
      <FeedbackButton />
    </div>
  );
}
